import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer"; // Import Footer
import Home from "./pages/Home";
import About from "./pages/About";
import Music from "./pages/Music";
import Curriculum from "./pages/Curriculum";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/music" element={<Music />} />
        <Route path="/curriculum" element={<Curriculum />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer /> {/* Add Footer Here */}
    </div>
  );
}

export default App;
